module.exports = __webpack_public_path__ + "static/img/Geelong-Cats.67a6db6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Geelong-Cats.jpg
// module id = OeJ9
// module chunks = 1